/**
 * Custom hook that encapsulates the sidebar open/close state.
 *
 * Replaces the repetitive pattern found across all page logic hooks:
 *   const [sidebarOpen, setSidebarOpen] = useState(false);
 *   const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
 */

import { useState } from "react";
import React from "react";

interface UseSidebarReturn {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useSidebar(initialOpen = false): UseSidebarReturn {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(initialOpen);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  return { sidebarOpen, toggleSidebar, setSidebarOpen };
}
